/* eslint-disable max-len */
import debounce from 'lodash/debounce';

/**
* NetConstruct Layout module.
*/
const self = {};

/**
* Function to equalize the heights of controls
* and keep them a consistent size as the window resizes
* @param {string} The jQuery selector to obtain the items who's height should be equalized
*/
self.equaliseHeights = function equaliseHeights(selector) {
  /**
   * private function that actually re-sizes
   */
  const resizeItems = function resizeItems() {
    // Select the items to resize
    const items = $(selector);
    let maxHeight = 0;

    // Set height back to default
    setDefaultHeight();

    // Determine the tallest item
    items.each(function each() {
      const $this = $(this);
      if ($this.height() > maxHeight) {
        maxHeight = $this.height();
      }
    });

    // Set the height of each of the items
    items.each(function each() {
      const $this = $(this);
      $this.height(maxHeight);
    });
  };

  function setDefaultHeight() {
    $(selector).each(function each() {
      $(this).height('auto');
    });
  }

  // When the window finishes re-sizing reset the height of each control
  // and then trigger the resize code
  $(window).resize(debounce(() => {
    setDefaultHeight();
    resizeItems();
  }));

  // Resize the items for the initial load
  resizeItems();
};

export default self;
